import stepStyles from "../../SelectProperty/SelectPropertyTypePage.module.css";

export const ResidentialWearAndTearStepPage = () => {
  return (
    <>
      <div className={stepStyles.wearDescription}>
        Upload photos or documents that show wear and tear of your property. This helps demonstrate
        a decrease in taxable value.
      </div>

      <div className={stepStyles.wearExamplesCard}>
        <div className={stepStyles.wearExamplesTitle}>Examples of what to upload:</div>
        <ul className={stepStyles.wearExamplesList}>
          <li>Photos of damaged areas</li>
          <li>Repair estimates</li>
          <li>Inspection reports</li>
          <li>Maintenance issues documentation</li>
        </ul>
      </div>
    </>
  );
};
